const config = require('../../config/config');

const COMPANY_NOT_FOUND = 'Company not found';

function base64_url_encode(data) {
    return btoa(encodeURIComponent(data)).replace(/\//g, '_').replace(/\+/g, '-').replace(/=/, '~');
}

function base64_url_decode(data) {
    return decodeURIComponent(atob(data.replace(/_/g, '/').replace(/-/g, '+').replace(/~/,'=')));
}

let returnJsonWithAuth = (res, state, postAuthCallback) => {
    if (res.status === 401 || res.status === 403) {
        fetch(config.adminAuthApiHost + "token", {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                code: state.authCode,
                redirect: window.location.origin,
                clientId: config.cognitoClientId
            }),
            credentials: "include"
        }).then(result => {
            if (result.status === 401) {
                window.location.href = config.tokenUrl + base64_url_encode(window.location.origin + window.location.pathname);
                return;
            }
            if (state.redirect) {
                const redirectValue = base64_url_decode(state.redirect);
                window.location.href = redirectValue;
                return;
            }
            postAuthCallback();
        }, error => {
            console.log(error);
        });
        return;
    }

    // The API returns this when the company doesn't exist or isn't in the user's group (Employee-Lite).
    if (res.status === 404) {
        return res.clone().json().then(body => {
            if (body && body.Data === COMPANY_NOT_FOUND) {
                // replace() so Back doesn't return to the inaccessible URL and redirect again
                window.location.replace('/?companyNotFound=true');
                return new Promise(() => {});
            }
            return res.json();
        }, () => res.json());
    }

    return res.json();
}

module.exports = returnJsonWithAuth;